module.exports = function() {
  return new Worker("/" + "unzip_imgs.worker.8585e8d470045cc9b7d1.js");
};